// config.ts

export const SUPABASE_CONFIG = {
  url: 'https://zdmjigyuurnhfdvrgjdk.supabase.co', 
  anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpkbWppZ3l1dXJuaGZkdnJnamRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ1MzE3MTUsImV4cCI6MjA4MDEwNzcxNX0.tyv40jLCWf2Cp_MQqXmesxw49I0y8Vr_iB8S9zbu14k'
};